export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does EC Design and Construction LLC serve?",
    a: "We're based in Clifton, New Jersey and work throughout Passaic County and the surrounding towns — including Passaic, Paterson, Wayne, Garfield, Fair Lawn, Haledon, Pompton Plains, Midland Park, Ridgewood, Wallington, Bloomfield, Montclair and Woodland Park. If your town isn't listed, call us and ask — we may still be able to help.",
  },
  {
    q: "What types of projects do you take on?",
    a: "Home remodeling, painting, masonry, roofing, retaining walls, pavers, flooring, new construction and general construction work. That covers everything from a single bathroom or a paver walkway to a full interior renovation or a ground-up build. If you're not sure which category your project falls under, just describe it when you call.",
  },
  {
    q: "How much does a project cost?",
    a: "It depends entirely on scope, materials and the condition of the property, so we don't publish prices we'd only have to revise. What we do instead is come out, look at the actual job, and give you a written estimate at no cost and with no obligation. Call (973) 931-5980 or request an estimate through the form on this site.",
  },
  {
    q: "Do you provide free estimates?",
    a: "Yes. Every estimate is free and comes with no obligation. We visit the property, measure, talk through what you want done, and put the scope and price in writing before anything is scheduled.",
  },
  {
    q: "Do you speak Spanish?",
    a: "Yes — we work in both English and Spanish. Sí, hablamos español. You can call, text or fill out the estimate form in either language and we'll respond in the one you're comfortable with.",
  },
  {
    q: "What are your hours?",
    a: "We're available Monday through Saturday, 8:00 AM to 5:00 PM, and closed on Sundays. If you need to reach us outside those hours, leave a message or use the estimate form and we'll get back to you the next working day.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Yes. We offer a 10% referral discount — refer a customer to us and you receive 10% off your next qualifying project. Ask us for the current terms when you request your estimate.",
  },
  {
    q: "Do you handle permits?",
    a: "Structural work, additions, new construction, and most roofing, electrical and plumbing changes require permits and inspections from your municipality. We'll tell you during the estimate which parts of your project need one and how permitting is handled, so there are no surprises once the job starts.",
  },
  {
    q: "How long does a project take?",
    a: "A bathroom remodel, a paver patio or a roof replacement are usually measured in days to a couple of weeks. A full kitchen, a finished basement or an addition runs longer, and new construction longer still. We give you a realistic timeline with the written estimate rather than an optimistic one — and we tell you if something changes.",
  },
  {
    q: "Do you take on small jobs, or only large projects?",
    a: "Both. A lot of our work is larger remodeling and construction, but we regularly take on smaller jobs — a masonry repair, a section of retaining wall, a room repaint, a leak or a structural fix. If it's in one of our trades, it's worth asking about.",
  },
  {
    q: "Do you work as a subcontractor for other contractors?",
    a: "Yes. We regularly frame, do masonry and handle finish work for other builders and general contractors who need a dependable crew. Call (973) 931-5980 to talk about availability and scope.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Ask us directly and we'll provide our current documentation before any work begins. We're a registered New Jersey LLC operating out of Clifton, and we're happy to put paperwork in your hands up front rather than after the fact.",
  },
];
